import { Party } from "src/app/party/party.model";
import {JournalItem} from "./journal-entry-detail.model";
import {Journal} from "./journal.model";
import {AccountingLifecycleFields} from "../../accounting-lifecycle.model";

export class JournalEntry implements AccountingLifecycleFields {

    entryId?: number;
    entryNumber: string;
    journal: Journal;
    entryDate: Date; // or Date if you prefer
    reference: string;
    party: Party;
    owningCompanyId: number;
    logisticsProjectId?: number;
    currencyCode: string;
    amount: number;
    state: string;
    documentStatus?: string;
    workflowStatus?: string;
    postingStatus?: string;
    submittedAt?: Date;
    submittedBy?: number;
    approvedAt?: Date;
    approvedBy?: number;
    postedAt?: Date;
    postedBy?: number;
    cancelledAt?: Date;
    cancelledBy?: number;
    voidedAt?: Date;
    voidedBy?: number;
    reversedAt?: Date;
    reversedBy?: number;
    closedAt?: Date;
    journalEntryId?: number;
    reversalJournalEntryId?: number;
    reversalReason?: string;
    sourceType?: string;
    sourceReference?: string;
    manualReasonCode?: string;
    manualReasonText?: string;
    createdFromModule?: string;
    requestedBy?: number;
    approvalDate?: Date;
    items: JournalItem[];

}
